import { useState, useEffect } from "react";
import { Button, 
  TextField, 
  FormControlLabel,
  Checkbox, 
  Box, 
  Link,
  Typography, 
  Grid,
  Divider, 
  Stack, 
  Paper,  
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle } from "@mui/material";
import googleIcon from "../../../../images/website-images/icons/google-icon.png";
import { darken, lighten } from '@mui/material/styles';
import { logout, signInWithGoogle, signUpWithEmail, signInWithEmail, resetPassword, getGeoData } from "../../../../common/Authenticator";

export default function CreateAccount({ data, isUserAuthenticated, userEmail, onNext, displayUserAlreadyHasPasswordLoginWithEmail, presetCreateAccountFormType, onChange }) {
  const [authStatus, setAuthStatus] = useState(isUserAuthenticated);

  const [formType, setFormType] = useState("signup");

  const [errors, setErrors] = useState({});

  const [openAcountAlreadyExistsDialog, setOpenAcountAlreadyExistsDialog] = useState(false);
  const [openInvalidEmailAndPasswordDialog, setOpenInvalidEmailAndPasswordDialog] = useState(false);

  const [openEmailResentDialog, setOpenEmailResentDialog] = useState(false); 

  const [marketingOptInChecked, setMarketingOptInChecked] = useState(false);
  const [marketingOptInAgreementLabel,setMarketingOptInAgreementLabel] = useState("I agree to receive marketing communications and understand I can unsubscribe at any time.");

  const [country, setCountry] = useState("");

  useEffect(() => {

    setFormType(presetCreateAccountFormType);

     // Define an async function inside useEffect
    const fetchGeoData = async () => {
      try {
        const geoData = await getGeoData();
        setCountry(geoData.country);
      } catch (error) {
        console.error("Failed to fetch geo data:", error);
        // Handle errors if necessary
      }
    };

    // Call the async function
    fetchGeoData();

  }, [presetCreateAccountFormType]);

  const handleGoogleSignIn = async () => {
    
    const signInResult = await signInWithGoogle(marketingOptInChecked,marketingOptInAgreementLabel);

    if (signInResult.user !== null && signInResult.user !== undefined)
    {
      //onNext(); // No need to do this the const unsubscribe = onAuthStateChanged(auth) on /subscribe will take care taking user to the next step

      if (signInResult.status === "already-has-password-login")
      {
          displayUserAlreadyHasPasswordLoginWithEmail();
      }
    }


  };

  const handleSignOutAndLogin = async () => {
    await logout();
    setFormType("signin");
    setAuthStatus(false);
  };

  const handleSignOutAndSignup = async () => {
    await logout();
    setFormType("signup");
    setAuthStatus(false);
  };

  const handleEmailSignup = async (e) => {
    e.preventDefault();

    try {
      localStorage.setItem("testMode", "true");

      const result = await signUpWithEmail(data.email, data.password, data.fullName, marketingOptInChecked,marketingOptInAgreementLabel);

      if (result.status === "account-already-exists")
      {

        setOpenAcountAlreadyExistsDialog(true);
      } else
      {
        //onNext();// No need to do this the const unsubscribe = onAuthStateChanged(auth) on /subscribe will take care taking user to the next step

      }
      

      //navigate("/app");
    
    } catch (error) {
      console.error("Signup Error:", error);
    } finally {
    }
  };

  const handleCloseAcountAlreadyExistsDialog = () => {
    setOpenAcountAlreadyExistsDialog(false);
  };

  const handleCloseInvalidEmailAndPasswordDialog = () => {
    setOpenInvalidEmailAndPasswordDialog(false);
  };

  const resendResetEmail = async (e,email) => {

    e.preventDefault();

    try {

     
      handleResetPassword(e,email);

      setOpenEmailResentDialog(true);
    
    } catch (error) {
      console.error("Login Error:", error);
    }
  };

  const handleCloseEmailResentDialog = () => {
    setOpenEmailResentDialog(false);
  };

   const handleResetPassword = async (e,email) => {

     e.preventDefault();

     try {

      await resetPassword(email);

      setFormType("checkemail");
     
     } catch (error) {
       console.error("Login Error:", error);
     }
   };



  const handleEmailLogin = async (e, method) => {

    e.preventDefault();

     try {
       const result = await method();

       let proceed= true;

       if (result != null && result.hasOwnProperty("emailSignInstatus")) // checks only for signin with email
       {
          if (result.emailSignInstatus === "successfully-signed-in")
          {

            proceed= true;
          
            } else if (result.emailSignInstatus === "invalid-email-password")
            {
              proceed= false;

              setOpenInvalidEmailAndPasswordDialog(true);
            }
          
       }

       if (proceed)
       {
        // onNext(); // No need to do this the const unsubscribe = onAuthStateChanged(auth) on /subscribe will take care taking user to the next step
         
       }

     } catch (error) {
       console.error("Login Error:", error);
     }
   };

  return (
    <Box mt={3} sx={{ minHeight: '420px' }}>
      {!authStatus ? (
        <div id="signUpForm">
          {formType === "signup" && 
          <div>
            {country !== "US" &&
             <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={marketingOptInChecked}
                      onChange={(e) => setMarketingOptInChecked(e.target.checked)}
                      color="primary"
                    />
                  }
                  label={marketingOptInAgreementLabel}
                />
                <br></br>
                  <Link to="/privacy.html" fontSize="12px" variant="body2" target="_blank">
                      Privacy Policy
                </Link>
              </Grid>
              }

            <Button
              fullWidth
              variant="outlined"
              onClick={handleGoogleSignIn}
              sx={{
                mt: 2,
                mb: 2,
                textTransform: "none",
                fontWeight: "bold",
                minHeight: '55px',
                fontSize: '17px',
                borderColor: lighten('#2D1B3F', 0.2),
                borderWidth: '1.5px',
              }}
            >
              <img
                src={googleIcon}
                alt="Google Icon"
                style={{ width: 20, marginRight: 10 }}
              />
              Sign up with Google
            </Button>

            <Box display="flex" alignItems="center" mb={2}>
              <Divider sx={{ flex: 1 }} />
              <Typography sx={{ mx: 2, color: "text.secondary" }}>OR</Typography>
              <Divider sx={{ flex: 1 }} />
            </Box>

            <form onSubmit={handleEmailSignup}>  
            <TextField
              fullWidth 
              required 
              label="Email"
              margin="normal"
              value={data.email}
              onChange={(e) => onChange({ email: e.target.value })}
              sx={inputStyles} 
              error={!!errors.email}
              helperText={errors.email}
            />
            <TextField
              fullWidth 
              required 
              label="Full Name"
              margin="normal"
              value={data.fullName}
              onChange={(e) => onChange({ fullName: e.target.value })}
              sx={inputStyles}
            />
            <TextField
              fullWidth 
              required 
              label="Password"
              type="password"
              margin="normal"
              value={data.password}
              onChange={(e) => onChange({ password: e.target.value })}
              sx={inputStyles}
            />

            <Box mt={2} display="flex" justifyContent="space-between">

              <Button
                component="button"
                onClick={() => setFormType("signin")}
                sx={{
                  color: '#5f5fff',
                  fontSize: '14px',
                  textDecoration: 'none',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  textTransform: 'none', // 👈 this line fixes the casing
                  '&:hover': {
                    textDecoration: 'underline'
                  }
                }}
              >
                Already have an account? <span style={{ fontWeight: 'bold',paddingLeft:'2px' }}>Sign in</span>
              </Button>
            
              <Button 
                type="submit"
                variant="contained"
                sx={{
                  backgroundColor: lighten('#2D1B3F', 0.1),
                  '&:hover': {
                    backgroundColor: darken('#2D1B3F', 0.1),
                  }
                }}
              >
                Get Started
              </Button>
            </Box>

            </form>   

          </div> 
          }

          {formType === "signin" && 
          <div>

          <form onSubmit={(e) => handleEmailLogin(e, () => signInWithEmail(data.email, data.password))}> 
          <TextField
              fullWidth 
              required
              label="Email"
              margin="normal"
              value={data.email}
              onChange={(e) => onChange({ email: e.target.value })}
              sx={inputStyles}
            />

            <TextField
              fullWidth 
              required
              label="Password"
              type="password"
              margin="normal"
              value={data.password}
              onChange={(e) => onChange({ password: e.target.value })}
              sx={inputStyles}
            />
             <div style={{float:'right',paddingBottom:'5px'}}>
                  <Button
                        component="button"
                        onClick={() => setFormType("reset")}
                        sx={{
                          color: '#5f5fff',
                          fontSize: '14px',
                          textDecoration: 'none',
                          background: 'none',
                          border: 'none',
                          cursor: 'pointer',
                          textTransform: 'none', // 👈 this line fixes the casing
                          '&:hover': {
                            textDecoration: 'underline'
                          }
                        }}
                      >
                        Forgot your password?
                  </Button>
              </div>

            <Box textAlign="center" pb={1} sx={{paddingTop:'15px', paddingBottom:'15px'}}>
              <Button
                variant="contained"
                type="submit"
                sx={{
                  backgroundColor: lighten('#2D1B3F', 0.1),
                  '&:hover': {
                    backgroundColor: darken('#2D1B3F', 0.1),
                  },
                  width:'100%',
                  height:'40px'
                }}
              >
                Sign in
              </Button>
            </Box>
            </form>

            <Box display="flex" alignItems="center" mb={2}>
              <Divider sx={{ flex: 1 }} />
              <Typography sx={{ mx: 2, color: "text.secondary" }}>OR</Typography>
              <Divider sx={{ flex: 1 }} />
            </Box>

            <Button
              fullWidth
              variant="outlined"
              onClick={(e) => handleGoogleSignIn()}
              sx={{
                mt: 2,
                mb: 2,
                textTransform: "none",
                fontWeight: "bold",
                minHeight: '55px',
                fontSize: '17px',
                borderColor: lighten('#2D1B3F', 0.2),
                borderWidth: '1.5px',
                margin:'0px',
                padding:'0px'
              }}
            >
              <img
                src={googleIcon}
                alt="Google Icon"
                style={{ width: 20, marginRight: 10 }}
              />
              Sign in with Google
            </Button>
            
            
            <Box textAlign="center" mt={3} sx={{ paddingTop: '0px' }}>
              <Button
                component="button"
                onClick={() => setFormType("signup")}
                sx={{
                  color: '#5f5fff',
                  fontSize: '14px',
                  textDecoration: 'none',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  textTransform: 'none', // 👈 this line fixes the casing
                  '&:hover': {
                    textDecoration: 'underline'
                  }
                }}
              >
                Don't have an account? <span style={{ fontWeight: 'bold',paddingLeft:'2px' }}>Sign Up</span>
              </Button>
            </Box>


          </div> 
          }

          {formType === "reset" && 
          <div>

          <Box textAlign="left" pb={1}>
            <Typography variant="body2" sx={{ fontSize: '15px', paddingBottom:'0px', paddingTop:'16px' }}>
            Enter the email address associated with your account and we'll send you a link to reset your password.
            </Typography>
          </Box>

          <form onSubmit={(e) => handleResetPassword(e,data.email)}>
          <TextField
              fullWidth 
              required
              label="Email"
              margin="normal"
              value={data.email}
              onChange={(e) => onChange({ email: e.target.value })}
              sx={inputStyles}
            />

            <Box textAlign="center" pb={1} sx={{paddingTop:'15px', paddingBottom:'15px'}}>
              <Button
                variant="contained"
                type="submit"
                sx={{
                  backgroundColor: lighten('#2D1B3F', 0.1),
                  '&:hover': {
                    backgroundColor: darken('#2D1B3F', 0.1),
                  },
                  width:'100%',
                  height:'40px'
                }}
              >
                Continue
              </Button>
            </Box>
            </form>

            
            
            <Box textAlign="center" mt={3} sx={{ paddingTop: '0px' }}>
              <Button
                component="button"
                onClick={() => setFormType("signup")}
                sx={{
                  color: '#5f5fff',
                  fontSize: '14px',
                  textDecoration: 'none',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  textTransform: 'none', // 👈 this line fixes the casing
                  '&:hover': {
                    textDecoration: 'underline'
                  }
                }}
              >
                Don't have an account? <span style={{ fontWeight: 'bold',paddingLeft:'2px' }}>Sign Up</span>
              </Button>

                <br></br>
              <Button
                component="button"
                onClick={() => setFormType("signin")}
                sx={{
                  color: '#5f5fff',
                  fontSize: '14px',
                  textDecoration: 'none',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  textTransform: 'none', // 👈 this line fixes the casing
                  '&:hover': {
                    textDecoration: 'underline'
                  }
                }}
              >
                Return to <span style={{ fontWeight: 'bold',paddingLeft:'2px' }}>Sign in</span>
              </Button>
            </Box>

   


          </div> 
          } {/* End reset*/}


        {formType === "checkemail" && 
          <div>

          <Box textAlign="center" pb={1}>
 
              <Typography component="h1" variant="h6" fontWeight="600" mt={2}>
              Check your email
              </Typography>
          </Box>


          <Box textAlign="left" pb={1}>
            <Typography variant="body2" sx={{ fontSize: '15px', paddingBottom:'0px', paddingTop:'16px' }}>
            Thanks! If <b>{data.email}</b> matches an email we have on file, then we've sent you an email containing further instructions for resetting your password.

            <br /><br />

                If you haven't received an email in 5 minutes, check your spam,{" "}
                <Box
                  component="span"
                  sx={{
                    color: '#5f5fff',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                    textDecoration: 'none',
                    '&:hover': { textDecoration: 'none' }
                  }}
                  onClick={(e) => resendResetEmail(e,data.email)}
                >
                  resend
                </Box>, or {" "}
                <Box
                  component="span"
                  sx={{
                    color: '#5f5fff',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                    textDecoration: 'none',
                    '&:hover': { textDecoration: 'none' }
                  }}
                  onClick={() => setFormType("reset")}
                >
                  try a different email
                </Box>
                .

            </Typography>
          </Box>

          <Box textAlign="center" pb={1} sx={{paddingTop:'25px', paddingBottom:'15px'}}>
              <Button
                variant="contained"
                onClick={() => setFormType("signin")}
                sx={{
                  backgroundColor: lighten('#2D1B3F', 0.1),
                  '&:hover': {
                    backgroundColor: darken('#2D1B3F', 0.1),
                  },
                  width:'100%',
                  height:'40px'
                }}
              >
                Return to Sign in
              </Button>
            </Box>
           
       

          </div> 
          } {/* End reset*/}



        </div>
      ) : (
        <div>
        <Paper elevation={3} sx={{ p: 4, backgroundColor: "#f9f9f9", borderRadius: 2 }}>
          <Typography variant="h6" gutterBottom>
            You already have an account
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            You're currently signed in as <strong>{userEmail}</strong>.
          </Typography>
          <Typography variant="body2" sx={{ mb: 3 }}>
            If you’d like to use a different account, you can either sign in or sign up as a different user, otherwise just continue to account information.
          </Typography>

          <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
            <Button
              variant="outlined"
              onClick={handleSignOutAndLogin}
              sx={{ textTransform: 'none' }}
            >
              Sign in as a different user
            </Button>

            <Button
              variant="outlined"
              onClick={handleSignOutAndSignup}
              sx={{ textTransform: 'none' }}
            >
              Sign up a new user
            </Button>

          </Stack>
        </Paper>

           <Box mt={2} display="flex" justifyContent="flex-end" sx={{paddingTop:'70px'}}>
            <Button
              variant="contained"
              onClick={onNext}
              sx={{
                backgroundColor: lighten('#2D1B3F', 0.1),
                '&:hover': {
                  backgroundColor: darken('#2D1B3F', 0.1),
                }
              }}
            >
              Continue To Account Info
            </Button>
          </Box>
        </div>

      )}

      <Dialog open={openAcountAlreadyExistsDialog} onClose={handleCloseAcountAlreadyExistsDialog}>
          <DialogTitle>Account Already Exists</DialogTitle>
          <DialogContent>
            <DialogContentText>
              An account with this email address already exists.<br></br><br></br>

              Please use a different email to sign up or click the 'Sign in' link below to log in. If you’ve forgotten your password, you can reset it there.

            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseAcountAlreadyExistsDialog} sx={{fontSize:'18px', fontWeight:'bold', border: "1px solid #8a8a8a", borderRadius: "12px", backgroundColor:'#f1f1f1'}} autoFocus>
              OK
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={openInvalidEmailAndPasswordDialog} onClose={handleCloseInvalidEmailAndPasswordDialog}>
          <DialogTitle>Invalid Email/Password</DialogTitle>
          <DialogContent>
            <DialogContentText>
              The email and/or password you entered is invalid.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseInvalidEmailAndPasswordDialog} sx={{fontSize:'18px', fontWeight:'bold', border: "1px solid #8a8a8a", borderRadius: "12px", backgroundColor:'#f1f1f1'}} autoFocus>
              OK
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={openEmailResentDialog} onClose={handleCloseEmailResentDialog}>
          <DialogTitle>Reset Password Sent</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Password reset email has been resent.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseEmailResentDialog} sx={{fontSize:'18px', fontWeight:'bold', border: "1px solid #8a8a8a", borderRadius: "12px", backgroundColor:'#f1f1f1'}} autoFocus>
              OK
            </Button>
          </DialogActions>
        </Dialog>


    </Box>
  );
}

const inputStyles = {
  '& .MuiOutlinedInput-root': {
    backgroundColor: '#FFFFFF',
    '& fieldset': {
      borderColor: lighten('#2D1B3F', 0.2),
      borderWidth: '1.5px',
      boxShadow: '0 0 8px 2px #FFFFFF'
    },
    '&:hover fieldset': {
      borderColor: '#0077CC',
      boxShadow: '0 0 8px 2px rgba(0,255,0,0.3)'
    },
    '&.Mui-focused fieldset': {
      borderColor: '#000000',
      boxShadow: '0 0 8px 2px #FFFFFF'
    },
  },
  '& .MuiInputLabel-root': {
    color: '#000000',
    '&:hover': {
      color: '#0077CC'
    },
    '&.Mui-focused': {
      color: 'currentColor'
    }
  },
};
